var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.55008 5.84631C3.60868 5.78311 3.67916 5.73206 3.75748 5.6961C3.83581 5.66013 3.92045 5.63995 4.00658 5.6367C4.09271 5.63345 4.17864 5.6472 4.25945 5.67716C4.34027 5.70712 4.41439 5.7527 4.47758 5.81131L7.75008 8.89744L11.0226 5.81131C11.0858 5.75271 11.1599 5.70713 11.2407 5.67717C11.3215 5.64722 11.4075 5.63347 11.4936 5.63672C11.5797 5.63997 11.6644 5.66015 11.7427 5.69612C11.821 5.73208 11.8915 5.78311 11.9501 5.84631C12.0087 5.90951 12.0543 5.98363 12.0842 6.06445C12.1142 6.14526 12.1279 6.23119 12.1247 6.31731C12.1214 6.40344 12.1012 6.48808 12.0653 6.56641C12.0293 6.64473 11.9783 6.71521 11.9151 6.77381L8.19633 10.2738C8.07498 10.3864 7.91559 10.4489 7.75008 10.4489C7.58458 10.4489 7.42518 10.3864 7.30383 10.2738L3.58508 6.77381C3.52188 6.71521 3.47083 6.64474 3.43487 6.56641C3.3989 6.48809 3.37872 6.40344 3.37547 6.31731C3.37222 6.23118 3.38596 6.14526 3.41593 6.06444C3.44589 5.98363 3.49147 5.90951 3.55008 5.84631Z",
    fill: "#5E5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon);
export default __webpack_public_path__ + "static/media/featuresIcon.04126db89371f954a5ed719c0833cffe.svg";
export { ForwardRef as ReactComponent };